import { lazy } from "react";
import {Navigate } from 'react-router-dom';

// project imports
import Loadable from "../component/Loadable/Index";
import MinimalLayout from "../layout/MinimalLayout/index";
import SignUp from "../container/signUp/Index";
import Forgot from "../container/forgotPassword/Index";
import Password from "../container/forgotPassword/Password";

const Login = Loadable(lazy(() => import("../container/login/Index")));
const Pricing = Loadable(lazy(() => import("../container/pricing/Index")));
const Seo = Loadable(lazy(() => import("../container/seoWithoutToken/Index")));
const LoginSuccess = Loadable(
  lazy(() => import("../container/loginSuccess/Index"))
);

const AutoWrite = Loadable(
  lazy(() => import("../container/autoWrite/Index"))
);

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/",
      element: <Login />,
    },

    {
      path: "/signup",
      element: <SignUp />,
    },
    {
      path: "/pricing",
      element: <Pricing />,
    },
    {
      path: "/signup/success",
      element: <LoginSuccess />,
    },
    {
      path: "/forgot",
      element: <Forgot />,
    },
    {
      path: "/password",
      element: <Password />,
    },  
    {
      path: "/autoWrite",
      element: <AutoWrite />,
    },    
    {
      path: "/seo",
      element: <Seo />,
    },   
    {
      path:"*" ,
      element:<Navigate to="/" /> 
    },
    
  ],
};

export default AuthenticationRoutes;
